import { createAction } from '@ngrx/store';

import { BasketValidation } from 'ish-core/models/basket-validation/basket-validation.model';
import { CheckoutStepType } from 'ish-core/models/checkout/checkout-step.type';
import { LineItemUpdate } from 'ish-core/models/line-item-update/line-item-update.model';
import { PaymentInstrument } from 'ish-core/models/payment-instrument/payment-instrument.model';
import { MessagesPayloadType } from 'ish-core/store/core/messages';
import { httpError, payload } from 'ish-core/utils/ngrx-creators';

export const startMultipleShippingCheckout = createAction(
  '[Multiple Shipping Checkout Internal] start the multiple shipping checkout'
);

export const startMultipleShippingCheckoutSuccess = createAction(
  '[Multiple Shipping Checkout Basket API] Start the checkout process success',
  payload<{ basketValidation: BasketValidation; targetRoute?: string }>()
);

export const continueMultipleShippingCheckout = createAction(
  '[Multiple Shipping Checkout Basket] Validate Basket and continue checkout',
  payload<{ targetStep: CheckoutStepType }>()
);

export const submitMultipleShippingOrder = createAction('[Multiple Shipping Basket] Basket Submit Order');

export const submitMultipleShippingBasket = createAction('[Multiple Shipping Basket API] Submit a Basket for Approval');

export const updateBasketItemAddress = createAction(
  '[Multiple Shipping Basket] Update Basket Item Address',
  payload<{ lineItemUpdate: LineItemUpdate }>()
);

/** Dedicated fail — do not reuse updateBasketItemFail (that triggers validateBasket). */
export const updateBasketItemAddressFail = createAction(
  '[Multiple Shipping Basket API] Update Basket Item Address Fail',
  httpError()
);

export const setMultipleShippingBasketPayment = createAction(
  '[Multiple Shipping Basket] Set a Payment at Basket ',
  payload<{ id: string }>()
);

export const createMultipleShippingBasketPayment = createAction(
  '[Multiple Shipping Basket] Create a Basket Payment',
  payload<{ paymentInstrument: PaymentInstrument; saveForLater: boolean }>()
);

export const displayMultipleCheckoutSuccessToast = createAction(
  '[Message Multiple Checkout] Multiple Checkout Success Toast',
  payload<MessagesPayloadType>()
);
